const SET_ARCHIVES = 'SET_ARCHIVES'

const INITIAL_STATE = {
    items: {},
}

const ACTION_HANDLERS = {
    [SET_ARCHIVES]: (state, { payload }) => {
        let itemsByCategory = {}

        payload.items.forEach(function (item) {
            const category = item.category.toLowerCase()
            if (itemsByCategory[category]) {
                itemsByCategory[category].push(item)
            } else {
                itemsByCategory[category] = [ item ]
            }
        })

        return {
            ...state,
            items: itemsByCategory,
        }
    },
}

export default (state = INITIAL_STATE, action) => {
    const handler = ACTION_HANDLERS[action.type]
    return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/reducers/archives.js